import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GoalCompletionModal from "./GoalCompletionModal";
import { Button } from "../../../components/ds";
import ModalComponent from "../../../components/UI/Modal/ModalComponent";
import {
  setSelectedDomain,
  setSelectedGoal,
} from "../../../slices/Employee/survey-CRR.slice";

const SurveyFooter = ({
  questionData,
  questionTitle,
  lastAnswer,
  IsSubmitClicked,
  goalInfo,
  domains,
  setIsSubmitClicked,
}) => {
  const { loading, goalsData } = useSelector((state) => state.goals);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalQueued, setIsModalQueued] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (IsSubmitClicked) {
      if (goalInfo?.goal?.status === "Complete" && !goalInfo?.prev_answer) {
        lastAnswer?.answer_id == "2"
          ? setIsModalQueued(true)
          : setIsModalVisible(true);
      }
      setIsSubmitClicked(false);
    }
  }, [goalInfo, goalInfo?.goal, goalInfo?.goal?.status]);

  useEffect(() => {
    if (isModalQueued && goalInfo?.goal?.status === "Complete") {
      setIsModalVisible(true);
      setIsModalQueued(false);
    }
  }, [goalInfo, goalInfo?.goal, goalInfo?.goal?.status]);

  const fetchNextGoal = () => {
    if (questionData?.next_goal?.is_new_domain) {
      const nextDomain =
        domains &&
        domains.find(
          (domain) => domain.id === questionData?.next_goal?.domain_id
        );
      dispatch(setSelectedDomain(nextDomain));
    } else {
      const nextGoal = goalsData.find(
        (goal) => goal.id === questionData?.next_goal?.id
      );
      dispatch(setSelectedGoal(nextGoal));
    }
  };

  const handleOk = () => {
    setIsModalVisible(false);
    fetchNextGoal();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="survey-footer-actions">
      {questionData?.next_goal?.id && (
        <Button
          className="next-goal-btn"
          variant="primary"
          disabled={loading}
          onClick={() => {
            fetchNextGoal();
          }}
        >
          <span className="next-goal-btn-text">
            {loading
              ? "Loading…"
              : questionData?.next_goal?.is_new_domain
                ? "NEXT DOMAIN"
                : "NEXT GOAL"}
          </span>
        </Button>
      )}

      <ModalComponent
        isModalVisible={isModalVisible}
        handleCancel={handleCancel}
        width={617}
        closable={!goalInfo?.has_attended_all_questions}
      >
        <GoalCompletionModal
          questionTitle={questionTitle}
          questionData={questionData}
          handleCancel={handleCancel}
          handleOk={handleOk}
          isAssessmentComplete={goalInfo?.has_attended_all_questions}
        />
      </ModalComponent>
    </div>
  );
};

export default SurveyFooter;
